/* eslint-disable */
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
import { auth } from '../../firebase';

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import List from "material-ui/List";
import ListItem from "material-ui/List/ListItem";
import Tooltip from "material-ui/Tooltip";


// @material-ui/icons
import { LaptopMac, Face, Info, Fingerprint, People, Publish, Code } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import SignOutButton from "components/CustomButtons/SignOutButton.jsx";
import IconButton from "components/CustomButtons/IconButton.jsx";

import navigationStyle from "assets/jss/material-kit-react/components/navigationStyle.jsx";
import * as routes from '../../routes/routes';


function NavigationAuth({ ...props }) {
const { classes } = props;
return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href={'/services'}
          color="transparent"
          target=""
          className={classes.navLink}
        >Services
          </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href={'/mystory'}
          color="transparent"
          target=""
          className={classes.navLink}
        >My Story
          </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          href={'/projectsea'}
          color="transparent"
          target=""
          className={classes.navLink}
        >Project SEA
          </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <SignOutButton
          onClick={auth.doSignOut}
          color="transparent"
          className={classes.navLink}
        >
          <Publish className={classes.icons} /> Sign Out
          </SignOutButton>
      </ListItem>
    
      <ListItem className={classes.listItem}>
        <Tooltip
          id="github-tooltip"
          title="Follow me on Github"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <IconButton
            href="https://github.com/Joevdelft"
            target="_blank"
            color="transparent"
            className={classes.navLink + " " + classes.socialIconsButton}
          >
            <i className={classes.socialIcons + " fab fa-github"} />
          </IconButton>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="My life on Instagram"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <IconButton
            color="transparent"
            href="https://www.instagram.com/flyandcodephoto/"
            target="_blank"
            className={classes.navLink + " " + classes.socialIconsButton}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </IconButton>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="linkedin-tooltip"
          title="Connect with me on LinkedIn"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <IconButton
            color="transparent"
            href="https://www.linkedin.com/in/jochgem-van-delft-28477b51/"
            target="_blank"
            className={classes.navLink + " " + classes.socialIconsButton}
          >
            <i className={classes.socialIcons + " fab fa-linkedin"} />
          </IconButton>
        </Tooltip>
      </ListItem>
    </List>
  );
}

export default withStyles(navigationStyle)(NavigationAuth);



// WEBPACK FOOTER //
// ./src/components/Header/NavigationAuth.jsx